import { FILE_UPLOAD, USERNAME } from '../constants/config';

export const validateUsername = (username) => {
  if (!username) {
    return 'Username is required';
  }
  if (username.length < USERNAME.MIN_LENGTH) {
    return `Username must be at least ${USERNAME.MIN_LENGTH} characters`;
  }
  if (username.length > USERNAME.MAX_LENGTH) {
    return `Username must be ${USERNAME.MAX_LENGTH} characters or less`;
  }
  if (!USERNAME.PATTERN.test(username)) {
    return 'Username can only contain letters, numbers, underscores, and dashes';
  }
  return null;
};

export const validateImageFile = (file) => {
  if (!file) {
    return 'Please select an image';
  }
  if (!FILE_UPLOAD.VALID_TYPES.includes(file.type)) {
    return 'Please select a JPEG, PNG, or WebP image';
  }
  if (file.size > FILE_UPLOAD.MAX_SIZE) {
    return 'Image size must be less than 5MB';
  }
  return null;
};